// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Checkbox = require("@mui/material/Checkbox").default;
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Delete = require("@mui/icons-material/Delete").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_web_src_settings(props) {
  var defaultIds = props.defaultIds;
  var onDelete = props.onDelete;
  var onTrustedChange = props.onTrustedChange;
  var onUrlChange = props.onUrlChange;
  var onAliasChange = props.onAliasChange;
  var onAdd = props.onAdd;
  var rndWebSrcSetting = function (src) {
    var isDefault = defaultIds.includes(src.id);
    var msg = src.err;
    return JsxPPXReactSupportU.createElementVariadicWithKey(src.id, Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, [
                React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: src.alias,
                          label: "Alias (optional)",
                          size: "small",
                          style: {
                            width: "150px"
                          },
                          onChange: Expln_React_common.evt2str(function (__x) {
                                onAliasChange(src.id, __x);
                              }),
                          disabled: isDefault
                        }), React.createElement(TextField, {
                          value: src.url,
                          label: "URL",
                          size: "small",
                          style: {
                            width: "400px"
                          },
                          onChange: Expln_React_common.evt2str(function (__x) {
                                onUrlChange(src.id, __x);
                              }),
                          disabled: isDefault
                        }), React.createElement(FormControlLabel, {
                          control: React.createElement(Checkbox, {
                                checked: src.trusted,
                                onChange: Expln_React_common.evt2bool(function (__x) {
                                      onTrustedChange(src.id, __x);
                                    })
                              }),
                          label: "Download without warning",
                          style: {
                            border: "solid 1px lightgrey",
                            marginTop: "-2px",
                            marginLeft: "2px",
                            paddingRight: "10px",
                            borderRadius: "7px"
                          }
                        }), JsxPPXReactSupportU.createElementWithKey("delete-button", IconButton, {
                          onClick: (function (param) {
                              onDelete(src.id);
                            }),
                          disabled: isDefault,
                          children: Caml_option.some(React.createElement(Delete, {}))
                        })),
                msg !== undefined ? React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, msg) : null
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: Caml_option.some(null)
            }, props.webSrcSettings.map(rndWebSrcSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: Caml_option.some(JsxPPXReactSupportU.createElementWithKey("add-button", IconButton, {
                            onClick: (function (param) {
                                onAdd();
                              }),
                            children: Caml_option.some(React.createElement(Add, {}))
                          }))
                }));
}

var make = MM_cmp_web_src_settings;

exports.make = make;
/* react Not a pure module */
